import EntityApi from "../Api/EntityApi";
import csv from './clubs.csv';
import getCountryISO3 from "country-iso-2-to-3";

const emptyApplication = {
    firstName: '', lastName: '', club: '', clubInput: '', clubObject: null, competitionClass: '', birthyear: '', noPhoto: false,
    countryObject: {value: 'SE', label: 'Sverige'}, gender: '', bus: false, status: 'Ny', fee: 0, disableClubInput: false
};

class RegistrationService {



    constructor(jsonApi, state, isTeam = false) {
        this.entityApi = new EntityApi(jsonApi);
        this.jsonApi = jsonApi;
        this.state = state;
        this.isTeam = isTeam;

        const applications = isTeam ?  [{...emptyApplication}, {...emptyApplication}, {...emptyApplication}, {...emptyApplication}, {...emptyApplication}] : [{...emptyApplication}];

        this.state.add('applications', applications);
        this.state.add('team', '');

        this.state.add('errorMsg', '');
        this.state.add('showErrorPopup', false);
        this.state.add('confirmMsg', false);
        this.state.add('competition', null);
        this.state.add('classes', null);
        this.state.add('consent', false);
        this.state.add('totalFee', 0);
        this.state.add('loading', false);
        this.state.add('response', null);
    }

    fetchCompetition() {
        if (this.state.loading) {
            return;
        }
        this.state.setLoading(true);
        this.state.setErrorMsg('');
        this.entityApi.list('Competition', 'publicRegistration',
            (resultType, list, data) => {
                if (data.status === 'success') {
                    this.updateData(list);
                }

                this.state.setLoading(false);
            },
            (res) => {
                if (res.status !== 'nochange') {
                    console.log('fetch failed:' + res.message);
                    this.state.setErrorMsg(res.message);
                }
                this.state.setLoading(false);
            },
            -1);
    }

    updateData (list) {
        const competition = list[0];
        const classes = competition.competitionClasses.sort((a, b) => {
            return a.order - b.order;
        });
        this.state.setCompetition(competition);
        this.state.setClasses(classes);
    }

    handleStateChange (index, property, value)  {
        if (index < 0) {
            this.state.set(property, value);
            return;
        }
        this.state.applications[index][property] = value;

        if (property === 'competitionClass') {
            if (this.isTeam) {
                for (let i= 1; i<5; i++) {
                    this.state.applications[i][property] = value;
                }
            }
        }


        if (property == 'clubInput' && value) {
            this.state.applications[index]['clubObject'] = null;
        }
        if (property == 'clubObject') {
            this.state.applications[index]['clubInput'] = '';
        }
        if (property == 'competitionClass' && this.isCompetitionClass(value)) {
            this.state.applications[index]['clubInput'] = '';
        }
        this.state.applications[index]['disableClubInput'] = this.isCompetitionClass( this.state.applications[index]['competitionClass'])
        this.state.setApplications(this.state.applications, true);
        this.calculateFee();
    }

    isCompetitionClass(classId) {
        const cs = this.state.classes.filter(c => c.id === classId);
        return cs && cs.length > 0 && cs[0].clubNeeded;
    }

    calculateFee () {
        let totalFee = 0;
        const isLate = this.state.competition.isLate;
        let sc;
        let teamDiscount = 0;
        this.state.applications.forEach((a) => {
            const selectedClass = this.state.classes.filter(c => c.id === a.competitionClass);
            if (selectedClass.length > 0 && a.birthyear.length === 4) {
                sc = selectedClass[0];
                a.fee = parseInt(this.isAdult(a.birthyear) ?
                    (isLate ? sc.adultLatePrice : sc.adultPrice) :
                    (isLate ? sc.youthLatePrice : sc.youthPrice));
                totalFee += this.isTeam ? Math.round(0.8 * a.fee) : a.fee;
            }
            if (a.bus) {
                totalFee += this.state.competition.busFee;
            }

        });
        this.state.setTotalFee(totalFee);
    }

    getSelectedClass(index) {
        const app = this.state.applications[index];
        const cs = this.state.classes.filter(c => c.id === app.competitionClass);
        return cs.length > 0 ? cs[0] : null;
    }

    isBussApplyOpen(index) {
        const c = this.getSelectedClass(index)
        return c ? c.busApplyOpen : false;
    }

    getBusLabel(index) {
        const c = this.getSelectedClass(index)
        return !c || this.isBussApplyOpen(index) ? 'Buss från Borensberg till start.' :
            'Bussplats kan inte garanteras.'
    }

    handleKeyPress (event) {
        if (event.key === "Enter") {
            this.onSaveForm(event);
        }
    }


    onSaveForm(event){

        let error = '';

        const getCountryISO3 = require("country-iso-2-to-3");

        if (this.isTeam && !this.state.team) {
            error += " Lagnamn behöver anges.\n";
        }
        if (this.isTeam && !this.state.applications[0].competitionClass) {
            error += " Klass behöver anges.\n";
        }
        this.state.applications.forEach((a, i) => {
            const errorEnd = (this.state.applications.length > 1 ? ' behöver anges för person '+(i + 1) : ' behöver anges') + ".\n";
            if (!a.firstName) {
                error += " Förnamn" + errorEnd;
            }
            if (!a.lastName) {
                error += " Efternamn" + errorEnd;
            }
            if (!a.clubInput && !a.clubObject) {
                error += (this.isCompetitionClass(a.competitionClass) ? ' Klubb' : " Klubb/ort") + errorEnd;
            }
            const birthyear = parseInt(a.birthyear);
            if (isNaN(birthyear) || birthyear < 1900 || birthyear > new Date().getFullYear()) {
                error += " Ogiltigt födelseår" + (this.state.applications.length > 1 ? ' för person '+(i + 1) : '') + '.';
            }
            if (!a.gender) {
                error += " Kön" + errorEnd;
            }
            if (!a.countryObject) {
                error += " Land" + errorEnd;
            }
            if (!this.isTeam && !a.competitionClass) {
                error += " Klass" + errorEnd;
            }
        })
        if (!this.state.consent) {
            error += " Godkännande krävs";
        }


        this.state.setErrorMsg(error);
        this.state.setShowErrorPopup(error);
        if (!error) {
            this.state.applications.forEach((a, i) => {
                a.country = getCountryISO3(a.countryObject.value);
                a.club = a.clubInput || a.clubObject.value;
            });
            this.onSave();
        }

    }

    onSave () {
        let text = '';

        text += `Totalt att betala: ${this.state.totalFee}`
        this.state.setConfirmMsg(text);
    }

    confirmed(isConfirmed) {
        this.state.setConfirmMsg(false);
        if (isConfirmed)
            this.callRegister();
    }

    addRegistration() {
        this.state.applications.push({ ...emptyApplication });
        this.state.setApplications(this.state.applications, true);
        this.calculateFee();
    }

    removeRegistration(index) {
        if (index > 0) {
            this.state.applications.splice(index, 1);
            this.state.setApplications(this.state.applications, true);
            this.calculateFee();
        }

    }

    callRegister () {
        this.state.setLoading(true);
        const path= 'admin/competition/registration.php?db='+this.entityApi.db+(this.isTeam ? '&team='+encodeURIComponent(this.state.team) : '');
        this.jsonApi.post(path, this.state.applications, (response) => {
                console.log('success');
                this.state.setResponse(response.data);
                sessionStorage.setItem('frontend.longReference', response.data.longReference)
                localStorage.removeItem('frontend.longReference');
                this.state.setLoading(false);
            },
            (data) => {
                console.log(data.message);
                this.state.setErrorMsg(data.message);
                this.state.setLoading(false);
            });
    }

    isAdult (birthYear) {
        return isNaN(birthYear) ? true : birthYear <= (new Date(this.state.competition.date).getFullYear() - 17);
    }

    async getClubOptions() {
        const options = [];
        const data = await fetch(csv);
        const text = await data.text()
        const list = text.split("\n").map(c => c.trim())
        const filtered = list.filter((item, index) => item && list.indexOf(item) === index);
        filtered.sort((a, b) => a.localeCompare(b))
        return filtered.map(c => {
            return  {value: c, label: c };
        })
    }
}

export default RegistrationService;